import { z } from 'zod/v4';

export const LanguageEnumRuntype = z.enum([
    'en',
    'de',
    'es',
    'fr',
    'it',
    'th',
    'zh',
    'ja',
    'hi',
    'cs',
    'nl',
    'hu',
    'pt',
    'fi',
    'sv',
    'pl',
    'tr',
]);
export type LanguageEnum = z.infer<typeof LanguageEnumRuntype>;
